import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ITag, IEdge } from '@api/types'
import { SpaceTagFragment } from '@api/fragments'

interface Payload {
  data: {
    viewer: {
      company: {
        search: {
          tags: {
            edges: IEdge<ITag>[]
          }
        }
      }
    }
  }
}

export default function spaceTagSearch({
  query,
  tag_type,
}: {
  query: string
  tag_type: string
}): Promise<ITag[]> {
  return client.gql.query({ query: q, variables: { query, tag_type } }).then(
    ({
      data: {
        viewer: {
          company: {
            search: {
              tags: { edges },
            },
          },
        },
      },
    }: Payload) => edges.map(({ node }) => node)
  )
}

const q = gql`
  query SpaceTagSearch($query: String!, $tag_type: SearchTagTypeEnum) {
    viewer {
      company {
        search(query: $query, type: all, tag_type: $tag_type) {
          tags(first: 9) {
            edges {
              node {
                ...SpaceTagFragment
              }
            }
          }
        }
      }
    }
  }
  ${SpaceTagFragment}
`
